"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
} from "@shesha-io/reactjs";
import {
  GlobalPublicPortalStyles,
  PublicPortalApplicationPlugin,
} from "@shesha-io/pd-publicportal";
import { WorkflowApplicationPlugin } from "@shesha-io/workflow";
import {EnterpriseApplicationPlugin} from "@shesha-io/enterprise";
import { ACCESS_TOKEN_NAME } from "@/app-constants";
export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();

  const isNoAuthPath = nextRouter.path?.includes("/no-auth");
  const hasStoredToken = typeof window !== "undefined" && !!localStorage.getItem(ACCESS_TOKEN_NAME);

  return (
    <GlobalStateProvider>
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={isNoAuthPath && !hasStoredToken}
        applicationKey="public-portal"
      >
        <GlobalPublicPortalStyles />
        <PublicPortalApplicationPlugin>
          <EnterpriseApplicationPlugin>
            <WorkflowApplicationPlugin>
              <StoredFilesProvider baseUrl={backendUrl} ownerId={""} ownerType={""}>
                {children}
              </StoredFilesProvider>
            </WorkflowApplicationPlugin>
          </EnterpriseApplicationPlugin>
        </PublicPortalApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
